import { IAvailablity } from "../types/availablity";

const getAvailablity = (input: IAvailablity[]) => {
  let _availableFlag = false;
  const SERVER_DAY = window.__SERVER_DATE__.getUTCDay();
  if (input.length > 0) {
    input.forEach(function (o) {
      if (o.day === SERVER_DAY) {
        if (compareDate(o)) {
          _availableFlag = true;
        }
      }
    });
  }
  return _availableFlag;
};

function compareDate(o: IAvailablity) {
  const SERVER_HR = window.__SERVER_DATE__.getUTCHours();
  const SERVER_MIN = window.__SERVER_DATE__.getUTCMinutes();
  let _ofset = 0;
  if (o.fromS === "PM") {
    _ofset = 12;
  }
  const _startDate = new Date(1990, 6, 29, o.fromHr + _ofset, o.fromMin, 0);

  _ofset = 0;
  if (o.toS === "PM") {
    _ofset = 12;
  }
  const _toDate = new Date(1990, 6, 29, o.toHr + _ofset, o.toMin, 0);

  const _serverDate = new Date(1990, 6, 29, SERVER_HR, SERVER_MIN, 0);

  if (_startDate.getTime() <= _serverDate.getTime() && _serverDate.getTime() <= _toDate.getTime()) {
    return true;
  }

  return false;
}

export default getAvailablity;
